import { yupResolver } from '@hookform/resolvers/yup';
import { CreateAnnouncementFormFields } from 'modules/notifications/interfaces/forms';
import { createAnnouncementValidationSchema } from './create-announcement-validation-schema';
import { useForm, UseFormReturn } from 'react-hook-form';

interface UseCreateAnnouncementFormsHook {
  form: UseFormReturn<CreateAnnouncementFormFields>;
}

export const useCreateAnnouncementForms = (message?: string): UseCreateAnnouncementFormsHook => {
  const formResolver = yupResolver(createAnnouncementValidationSchema);

  const form = useForm<CreateAnnouncementFormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: {
      message: message ?? '',
    },
  });

  return {
    form,
  };
};
